import React, { useState } from 'react';
import './Services.css';
import { SERVICE_CATEGORIES } from '../data/content';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Services() {
const { state } = useLocation();
const [activeTab, setActiveTab] = useState(state?.activeTab ?? 0);
const [expandedGroup, setExpandedGroup] = useState(state?.expandedGroup ?? null);

React.useEffect(() => {
  if (state?.activeTab !== undefined) setActiveTab(state.activeTab);
  if (state?.expandedGroup !== undefined) setExpandedGroup(state.expandedGroup);
}, [state]);
  const navigate = useNavigate()
  const active = SERVICE_CATEGORIES[activeTab];

  const handleTabChange = (i) => {
  setActiveTab(i);
  setExpandedGroup(null);
  navigate('.', { state: { activeTab: i, expandedGroup: null }, replace: true });
};
  const toggleGroup = (groupLabel) => {
  setExpandedGroup(groupLabel);
  navigate('.', { state: { activeTab, expandedGroup: groupLabel }, replace: false });
};

  // If category has groups and a group is expanded, show that group's services
  // If no group expanded but has groups, show ALL services flat
  const displayServices = active.groups
    ? (expandedGroup
      ? active.groups.find(g => g.label === expandedGroup)?.services || []
      : active.directServices || [])
    : active.services;

  return (
    <section className="services-section">

      {/* ── Banner ── */}
      <div className="services-banner">
        <div className="services-banner-img" />
        <div className="services-banner-overlay" />
        <div className="services-banner-content">
          <div className="services-banner-tag">What We Do</div>
          <h1 className="services-banner-title">Our Services</h1>
          <p className="services-banner-sub">
            End-to-end engineering solutions — PCB design, chip development, mechanical systems, and software
          </p>
        </div>
      </div>

      {/* ── Main layout ── */}
      <div className="services-layout">

        {/* Sidebar */}
        <aside className="services-sidebar">
          <div className="services-sidebar-label">Service Divisions</div>
          {SERVICE_CATEGORIES.map((cat, i) => (
            <button
              key={cat.id}
              className={`svc-tab${activeTab === i ? ' svc-tab--active' : ''}`}
              onClick={() => handleTabChange(i)}
              style={{ '--tab-accent': cat.accent }}
            >
              <span className="svc-tab-icon">{cat.icon}</span>
              <span className="svc-tab-label">{cat.label}</span>
              <span className="svc-tab-arrow">→</span>
            </button>
          ))}

          {/* Contact nudge */}
          <div className="services-sidebar-cta">
            <div className="svc-cta-title">Need guidance?</div>
            <p className="svc-cta-sub">Talk to our engineers about your project.</p>
            <a href="/contact" className="svc-cta-btn">Get Free Consultation</a>
          </div>
        </aside>

        {/* Content panel */}
        <div className="services-panel" key={active.id}>

          {/* Panel header */}
          <div className="services-panel-header" style={{ '--panel-accent': active.accent }}>
            <div className="services-panel-header-left">
              <div className="services-panel-icon">{active.icon}</div>
              <div>
                <div className="services-panel-tag" style={{ color: active.accent }}>
                  {active.label}
                </div>
                <h2 className="services-panel-title">{active.tagline}</h2>
                <p className="services-panel-desc">{active.description}</p>
              </div>
            </div>
            <div className="services-panel-count">
              <span>{active.services.length}</span>
              <small>Services</small>
            </div>
          </div>

          {/* ── Group buttons (only for categories that have groups) ── */}
          {/* ── Group buttons (Semiconductor, Wiring Harness) ── */}
          {active.groups && (
            <div className="svc-groups-bar">
              {expandedGroup && (
                <button
                  className="svc-group-back"
                  onClick={() => setExpandedGroup(null)}
                  style={{ color: active.accent }}
                >
                  ← Back
                </button>
              )}
              {!expandedGroup && active.groups.map((group) => (
                <button
                  key={group.label}
                  className="svc-group-btn"
                  style={{ '--grp-accent': active.accent }}
                  onClick={() => toggleGroup(group.label)}
                >
                  <span className="svc-group-icon">{group.icon}</span>
                  <span className="svc-group-label">{group.label}</span>
                  <span className="svc-group-count" style={{ background: `${active.accent}18`, color: active.accent }}>
                    {group.services.length}
                  </span>
                  <span className="svc-group-arrow" style={{ color: active.accent }}>→</span>
                </button>
              ))}
              {expandedGroup && (
                <div className="svc-group-active-label" style={{ color: active.accent }}>
                  {active.groups.find(g => g.label === expandedGroup)?.icon} {expandedGroup}
                </div>
              )}
            </div>
          )}

          {/* Cards grid — shows directServices OR expanded group services */}
          <div className="services-cards-grid">
            {displayServices.map((svc, i) => (
              <div
                key={svc.slug}
                className="svc-card"
                style={{ '--svc-color': active.accent, animationDelay: `${i * 0.06}s` }}
               onClick={() => svc.slug && navigate('/services/detail', { state: { slug: svc.slug, activeTab } })}
               onKeyDown={e => e.key === 'Enter' && svc.slug && navigate('/services/detail', { state: { slug: svc.slug, activeTab } })}
              >
                <div
                  className="svc-card-img"
                  style={{ backgroundImage: `url('${svc.image}')` }}
                />
                <div className="svc-card-body">
                  <div className="svc-card-top">
                    <span className="svc-card-icon">{svc.icon}</span>
                    <span className="svc-card-short" style={{ color: active.accent }}>{svc.short}</span>
                  </div>
                  <h3 className="svc-card-title">{svc.title}</h3>
                  <p className="svc-card-desc">{svc.desc}</p>
                  <div className="svc-card-footer">
                    <span className="svc-card-learn" style={{ color: active.accent }}>
                      Learn More
                    </span>
                    <span className="svc-card-arrow-btn" style={{ background: active.accent }}>→</span>
                  </div>
                </div>
                <div className="svc-card-bar" style={{ background: active.accent }} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}